<header>
  <div id="header-sticky" class="py-2"
    [ngClass]="['header__area', transparent ? 'header__transparent' : '', header_big ? 'box-25' : !white_bg ? 'grey-bg' : '', sticky ? 'sticky' : '']" id="header-sticky">
    <div [ngClass]="header_big ? 'container-fluid' : 'container'">
      <div class="row align-items-center">
        <div
          [ngClass]="header_big ? 'col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12' : 'col-xl-3 col-lg-3 col-md-4 col-sm-4'">
          <div class="logo">
            <a routerLink="/home">
              <img src="/assets/img/logo/dark-logo.svg" alt="logo" class="site-logo">
            </a>
          </div>
        </div>

        <div
          [ngClass]="header_big ? 'col-xl-7 col-lg-6 col-md-2 col-sm-1 col-2' : 'col-xl-9 col-lg-9 col-md-8 col-sm-8'">
          <div class="header__right p-relative"
            [ngClass]="{'d-flex justify-content-between align-items-center': !header_big}">
            <div [ngClass]="{'main-menu': true, 'main-menu-2': header_big, 'text-center': header_big, 'd-none d-lg-block': true}">
              <!-- nav menu start -->
              <app-nav-manus></app-nav-manus>
              <!-- nav menu end -->
            </div>
            <div class="mobile-menu-btn d-lg-none">
              <a (click)="utilsService.handleOpenMobileMenu()" class="mobile-menu-toggle cursor-pointer">
                <i class="fas fa-bars"></i>
              </a>
            </div>
            <div *ngIf="!header_big" class="header__action">
              <ul>
                <li>
                  <a (click)="utilsService.handleSearchOpen()" class="search-toggle cursor-pointer">
                    <i class="ion-ios-search-strong"></i> Search
                  </a>
                </li>
                <li>
                  <a class="cart cursor-pointer">
                    <i class="ion-bag"></i> Cart <span>({{cartService.totalPriceQuantity().quantity}})</span>
                  </a>
                  <!-- mini cart start -->
                  <app-mini-cart></app-mini-cart>
                  <!-- mini cart end -->
                </li>
                <li> <a class="cursor-pointer"><i class="far fa-bars"></i></a>
                  <!-- extra info start -->
                  <app-extra-info></app-extra-info>
                  <!-- extra info end -->
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div *ngIf="header_big" class="col-xl-3 col-lg-4 col-md-6 col-sm-7 col-10">
          <div class="header__action header__action-2 f-right">
            <ul>
              <li>
                <a (click)="utilsService.handleSearchOpen()" class="search-toggle cursor-pointer">
                  <i class="ion-ios-search-strong"></i> Search
                </a>
              </li>
              <li>
                <a class="cart cursor-pointer"><i class="ion-bag"></i> Cart
                  <span>({{cartService.totalPriceQuantity().quantity}})</span>
                </a>
                <!-- mini cart start -->
                <app-mini-cart></app-mini-cart>
                <!-- mini cart end -->
              </li>
              <li> <a class="cursor-pointer"><i class="far fa-bars"></i></a>
                <!-- extra info start -->
                <app-extra-info></app-extra-info>
                <!-- extra info end -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- search popup start -->
<app-search-popup></app-search-popup>
<!-- search popup end -->

<!-- mobile offcanvas start -->
<app-offcanvas></app-offcanvas>
<!-- mobile offcanvas end -->
